var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4167 10.0833C17.4167 9.33388 17.4167 8.64463 17.2771 8.30772C17.1375 7.97081 16.8726 7.70587 16.3427 7.17598L12.0009 2.83414C11.5436 2.37684 11.315 2.14817 11.0316 2.01269C10.9727 1.9845 10.9124 1.9595 10.8508 1.93776C10.5546 1.83325 10.2313 1.83325 9.58448 1.83325C6.60992 1.83325 5.12262 1.83325 4.11522 2.64548C3.9117 2.80958 3.72632 2.99495 3.56223 3.19847C2.75 4.20587 2.75 5.69317 2.75 8.66777V12.8333C2.75 16.2902 2.75 18.0187 3.82394 19.0926C4.89789 20.1666 6.62636 20.1666 10.0833 20.1666H17.4167M11 2.29159V2.74992C11 5.34265 11 6.639 11.8055 7.44446C12.6109 8.24992 13.9073 8.24992 16.5 8.24992H16.9583",
    stroke: "#FF2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2501 12.8333H17.4167C16.9105 12.8333 16.5001 13.2436 16.5001 13.7499V15.1249M16.5001 15.1249V17.4166M16.5001 15.1249H18.7917M6.41675 17.4166V15.5833M6.41675 15.5833V12.8333H7.79175C8.55114 12.8333 9.16675 13.4489 9.16675 14.2083C9.16675 14.9676 8.55114 15.5833 7.79175 15.5833H6.41675ZM11.4584 12.8333H12.637C13.5049 12.8333 14.2084 13.5173 14.2084 14.3611V15.8888C14.2084 16.7326 13.5049 17.4166 12.637 17.4166H11.4584V12.8333Z",
    stroke: "#FF2A2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ea9c001c65df909210a1acce7652c931.svg";
export { ForwardRef as ReactComponent };